const appVersion = typeof VERSION !== 'undefined' && VERSION ? VERSION : 'latest'; // eslint-disable-line no-undef
const EXPIRES_IN_DAYS = 365;

export default {
  /**
   * @description Set cookie
   * @param name
   * @param value
   * @param exp
   */
  set(name, value, exp) {
    let expTime = exp;
    const d = new Date();
    let expires = '';

    if (isNaN(expTime)) { // eslint-disable-line
      expTime = EXPIRES_IN_DAYS;
    }

    d.setTime(d.getTime() + (expTime * 24 * 60 * 60 * 1000));
    expires = `expires=${d.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  },

  /**
   * @description Get cookie
   * @param name
   */
  get(name) {
    const cname = `${name}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(cname) === 0) {
        return c.substring(cname.length, c.length);
      }
    }
    return '';
  },

  setVersionned(name, value, exp) {
    this.set(`${name}_${appVersion}`, value, exp);
  },

  getVersionned(name) {
    this.get(`${name}_${appVersion}`);
  },

  /**
   * Set element 'key' in the store to value, value must be json
   *
   * @param key
   * @param value
   * @return {*}
   */
  setJSON(key, value) { // eslint-disable-line no-unused-vars
    this.set(key, JSON.stringify(value));
  },

  /**
   * Get the element key in the store , it is supposed to be a JSON value.
   *
   * @param key
   * @return {*}
   */
  getJSON(key) {
    const value = this.get(key);
    return value ? JSON.parse(value) : {};
  },

  /**
   * Remove a cookie
   *
   * @param name
   * @return {*}
   */
  remove(name) {
    this.set(name, '', -1);
  },
};
